import React from 'react'
import { AppWrap, AppWrapNavVariants } from 'apps/marketplace/components/AppWrap'
import { LandingPage } from './LandingPage'

export const APP_NAME = 'edi-tools'

export function App() {
  return (
    <AppWrap appName={APP_NAME} title='EDI Tools' variant={AppWrapNavVariants.top}>
      <section className='container-fluid pt8' data-test={APP_NAME}>
        <LandingPage />
      </section>
    </AppWrap>
  )
}
